module.exports = __webpack_public_path__ + "static/media/Verkoopnou_Website_Terms_and_Conditions.825ba1b2.pdf";